<style>
  .toolbutton {
  width: 160px;
}
.shadowLogo {
width:300px;
/*box-shadow: 0 0 12pt rgba(0, 0, 0, 0.25);*/
/*border: 1px solid #ccc;*/
}
</style>
<div class="page">
  <main class="notools nopad">
    @if (organisation?.isTrialExpired ) {
      <div class="panelwarn layout-row-gap-025 layout-align-center layout-justify-center">
        <div>Your trial period expired {{organisation.trialEnds | date}}. To continue using barxui, setup a <a routerLink="/settings/organisation">paid subscription</a> or contact support if you would like an extension.</div>
      </div>
    }
    <div class="layout-row-gap-2e layout-justify-center layout-align-stretch layout-col-lt-lg layout-justify-lt-lg-start layout-align-lt-lg-stretch" style="margin:3em;">
      <div class="layout-row-gap-1r layout-col-lt-md layout-justify-evenly layout-align-start">
        <div class="layout-flex-25">
          <!--          <img src="./assets/barxuinewblack.png">-->
          <img alt="barxui" src="/assets/barxuilogo4.png" title="bar-zoo-eee" class="shadowLogo">
          @if (!organisation?.isActivated) {
            <h2>Lets get started!</h2>
            <div>
              To begin using barxui, please enter your organisation details and start your trial.
            </div>
            <div>
              <button data-cy="home-button" mat-raised-button color="primary" class="btn"
                routerLink="/settings/organisation">
                <mat-icon>business</mat-icon>
                Settings
              </button>
            </div>
          } @else {
            @if (user.isSubscriber || user.isAdmin) {
              <h2>Getting Started</h2>
              <p>Its easy to get started printing great looking labels with barxui. Just click one of the buttons below
                or select from the Recent Activity.
              </p>
              <div class="layout-col-gap-05 layout-align-start">
                <div class="layout-row-gap-05 layout-col-lt-lg layout-justify-between layout-align-center layout-justify-lt-lg-start">
                  <div>Add sample labels and data</div>
                  <div>
                    <button mat-raised-button (click)="addSamples()" class="toolbutton">Add
                      Samples
                    </button>
                  </div>
                </div>
            </div>
          } @else {
            <!--              Nothing to display here for operators etc.-->
          }
          <h2 style="margin-top:1rem">Recent Activity</h2>
          @if (!!recentActivity.length) {
            <ul style="list-style-type: none;">
              @for (ra of recentActivity; track ra) {
                <li>
                  <div class="layout-row-gap-025 layout-align-center">
                    <mat-icon>{{getIcon(ra.kind)}}</mat-icon>
                    <a [routerLink]="ra.url" [queryParams]="ra.params">{{ra.label}}</a>
                  </div>
                </li>
              }
            </ul>
            <button mat-raised-button routerLink="/design">View All Labels</button>
          } @else {
            <h4>Your recent activity will show here.</h4>
          }
          <div class="layout-row-gap-025 layout-align-center" style="margin-top:2em">
            <label for="showStartup">Show Welcome page on Startup</label>
            <mat-checkbox id="showStartup" [checked]="showAtStartup" (change)="toggleShowAtStartup()"></mat-checkbox>
          </div>
        }
      </div>
      <div class="layout-flex-50" [innerHtml]="newsContent | async | safe:'html' ">
      </div>
    </div>
  </div>
</main>
</div>
